import FirstSlider from "./FirstSlider";
import SecondSlider from "./SecondSlider";


export default function MusicSlide({ sliderData, grpGliderData, onViewAll }) {

    return (
        <>
            <SecondSlider sliderData={sliderData} onViewAll={() => onViewAll("yelp")} />
            <FirstSlider grpGliderData={grpGliderData} onViewAll={() => onViewAll("groupon")} />
        </>
    )
}
